import API from 'services/api';

export const getCounties = () => API.get('api/root/counties')?.then(response => response?.data);
